import styled from 'styled-components';
import RatingStarIcon from '../../../../../Icons/RatingStarIcon';
import {FlexCentered, SmallSectionHeader} from '../../../../CommonStyleUtils/dwebCommon.styles';
import {textSizes, headingSizes} from '@stencil/build-theme';

export const StarDiv = styled(RatingStarIcon)(
  props => `
  margin-right:${props.theme.spacing.small};
  color: ${props.theme.colors.goYellow.dark};
`,
);

export const HotelCategoryWrapDiv = styled(FlexCentered)(
  props => `
  padding: ${props.theme.spacing.base} 0;
`,
);

export const HotelNameTextSpan = styled.span(props => ``);

export const HotelNameTextAnchor = styled.a(props => ``);

export const HotelCatgegory = styled.div(
  props => `
  border: 1px solid ${props.theme.colors.goBrandBlue.light};
  padding:${props.theme.spacing.custom(3)} ${props.theme.spacing.small};
  border-radius: ${props.theme.misc.borderRadius.small};
  text-transform:uppercase;
  ${props.isAltAcco && 'margin-left:0.5rem;'}
`,
);

export const ReviewHotelNameHeading = styled.h3(
  props => `
  ${headingSizes.Small};
  padding-bottom:${props.theme.spacing.small};
  /* for ellipses */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 25.5rem;
  /* https://stackoverflow.com/questions/9931542/css-text-overflow-ellipsis-not-displaying */

`,
);

export const AddressSpan = styled.span(
  props => `
  color:${props.theme.colors.downriver.medium};

`,
);

export const ReviewByUserDiv = styled.div(
  props => `
  display:flex;
  padding:${props.theme.spacing.base} 0;
`,
);

export const ReviewPointWrapDiv = styled.div(
  props => `
  display: flex;
  padding:${props.theme.spacing.xsmall} ${props.theme.spacing.small};
  background:${props.backgroundColor ? props.backgroundColor : props.theme.colors.goGreen.base};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-right:${props.theme.spacing.base};
  visibility: ${props.showRating ? 'visible' : 'hidden'};
  min-height: 20px;
`,
);

export const ReviewPointTextSpan = styled.span(
  props => `
  display:flex;
  color:${props.theme.colors.goWhite.base};
  font-weight: 600;

`,
);
export const HotelNameLocationWrapper = styled.div`
  min-height: 4.8rem;
`;
